export default function TableBlock({ settings }) {
  const { padding, margin, rows, showHeader, striped, headerBackgroundColor, headerTextColor, tableBorderColor, cellPadding, fontSize, fontFamily, color, tableWidth } = settings

  const containerStyle = {
    padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`,
    margin: `${margin.top} ${margin.right} ${margin.bottom} ${margin.left}`
  }

  const tableStyle = {
    width: tableWidth || '100%',
    borderCollapse: 'collapse',
    border: `1px solid ${tableBorderColor || '#dee2e6'}`,
    fontFamily: fontFamily || 'Arial, sans-serif',
    fontSize: fontSize || '14px'
  }

  const cellStyle = {
    padding: cellPadding || '10px',
    border: `1px solid ${tableBorderColor || '#dee2e6'}`,
    color: color || '#333333'
  }

  const headerStyle = {
    ...cellStyle,
    backgroundColor: headerBackgroundColor || '#f8f9fa',
    color: headerTextColor || '#333333',
    fontWeight: 'bold',
    textAlign: 'left'
  }

  if (!rows || rows.length === 0) {
    return (
      <div style={containerStyle}>
        <div style={{ padding: '1.5rem', textAlign: 'center', color: '#94a3b8', fontSize: '0.85rem', border: '1px dashed #e5e7eb', borderRadius: '4px' }}>
          Configure table data in settings
        </div>
      </div>
    )
  }

  const startIdx = showHeader ? 1 : 0

  return (
    <div style={containerStyle}>
      <table style={tableStyle}>
        {showHeader && rows[0] && (
          <thead>
            <tr>
              {rows[0].map((cell, idx) => (
                <th key={idx} style={headerStyle}>{cell}</th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rows.slice(startIdx).map((row, rowIdx) => (
            <tr key={rowIdx}>
              {row.map((cell, cellIdx) => (
                <td key={cellIdx} style={{
                  ...cellStyle,
                  backgroundColor: striped && rowIdx % 2 === 1 ? '#f8f9fa' : 'transparent'
                }}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
